import React from 'react';

import {
  convertLocationParamsToFetchParams,
  useProcedures,
} from 'app/procedures/api';
import {QuizGenericObjectsSidebar} from 'app/quizzes/components/QuizDetailPage/QuizGenericObjectsSidebar';
import {PROCESS_CREATE_PAGE_URL} from 'app/urls';

import type {LinkedDocumentType, QuizSerializedType} from 'sweet-types';

interface Props {
  quiz: QuizSerializedType;
  attachedItems: Array<LinkedDocumentType>;
}

export function QuizProceduresSidebar({quiz, attachedItems}: Props) {
  return (
    <QuizGenericObjectsSidebar
      quizId={quiz.id}
      quizURL={quiz.url}
      closeUrl={quiz.html_url}
      attachedItems={attachedItems}
      contentType={'procedure'}
      createURL={PROCESS_CREATE_PAGE_URL}
      useDataHook={useProcedures}
      paramsConverter={convertLocationParamsToFetchParams}
      canEdit={quiz.can_edit}
    />
  );
}
